// Shared by the DOM origin pin / chip through the --search-blue CSS token.
export const SEARCH_BLUE = '#2563eb';
// Search results opened from an assistant link (/map?hits=ID1,ID2,…): rank labels and the initial view.
export const MAX_HITS = 25;
export function readHits(value) {
  const out = [];
  for (const raw of String(value ?? '').split(',')) {
    const id = raw.trim().toUpperCase();
    if (/^[0-9A-Z]{4}$/.test(id) && !out.includes(id)) out.push(id);
  }
  return out.slice(0, MAX_HITS);
}
// Bounds over the results; with a position the box is mirrored around it, so following (position in the
// centre) still shows every result. Never closer than maxZoom (the near level).
export function hitBounds(coords, position = null) {
  const all = position ? [position, ...coords, ...coords.map(([x, y]) => [2 * position[0] - x, 2 * position[1] - y])] : coords;
  const xs = all.map(c => c[0]), ys = all.map(c => c[1]);
  return [[Math.min(...xs), Math.min(...ys)], [Math.max(...xs), Math.max(...ys)]];
}
export function fitCamera(map, coords, position, padding, maxZoom) {
  if (!coords.length) return null;
  const bounds = hitBounds(coords, position);
  const flat = bounds[0][0] === bounds[1][0] && bounds[0][1] === bounds[1][1];
  const camera = flat ? null : map.cameraForBounds(bounds, {padding, maxZoom});
  const zoom = Math.min(maxZoom, camera?.zoom ?? maxZoom);
  return {center: position ?? (camera?.center ?? coords[0]), zoom};
}
export const hitSpriteExpression = theme => ['concat', `hit|${theme}|`, ['to-string', ['get', 'rank']]];
export const hitLabelWidth = () => 28;
// Large, high-contrast rank tile left of a search-result pin.
export function drawHitLabel(rank, theme, canvas = document.createElement('canvas'), ratio = 2, profile = {}) {
  const text = String(rank), w=28,h=28;
  canvas.width=32*ratio;canvas.height=32*ratio;
  const ctx=canvas.getContext('2d');ctx.scale(ratio,ratio);
  ctx.fillStyle=SEARCH_BLUE;ctx.beginPath();ctx.roundRect(2,2,w,h,5);ctx.fill();
  ctx.shadowColor='transparent';ctx.strokeStyle='#ffffff';ctx.lineWidth=1.5;ctx.stroke();
  ctx.fillStyle='#ffffff';ctx.font='700 18px Inter, system-ui, sans-serif';
  ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillText(text,16,16.5);
  return canvas;
}
function addHitSprite(map, id, profile = {}) {
  if (map.hasImage(id)) return;
  const [, theme, rank] = id.split('|');
  const canvas = drawHitLabel(rank, theme, undefined, 2, profile);
  map.addImage(id, canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height), {pixelRatio: 2});
}
export function installHitSprites(map, profile = () => ({})) {
  map.on('styleimagemissing', event => { if (event.id.startsWith('hit|')) addHitSprite(map, event.id, profile()); });
}
// Images before the data, like the bubbles (avoids missing-image warnings and a blank first frame).
export function prepareHitSprites(map, features, theme, profile = {}) {
  for (const f of features) if (f.properties.rank) addHitSprite(map, `hit|${theme}|${f.properties.rank}`, profile);
}

export function refreshHitSprites(map, profile) {
  for (const id of map.listImages()) {
    if (!id.startsWith('hit|')) continue;
    const [,theme,rank] = id.split('|'), canvas = drawHitLabel(rank,theme,undefined,2,profile);
    map.updateImage(id,canvas.getContext('2d').getImageData(0,0,canvas.width,canvas.height));
  }
}
